/**
 * Reference Data tab (§8.1) — sub-nav across the six reference entities.
 */

import React from 'react';
import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import ProfilesManager from './ProfilesManager';
import MarginsManager from './MarginsManager';
import EntityManager from './EntityManager';
import { splitRulesConfig, referralRulesConfig, loaFeesConfig, emailAliasesConfig } from './entityConfigs';

export default function ReferenceTab({ isSuperAdmin, onTryInCalculator }) {
  return (
    <Tabs size="sm" variant="soft-rounded" colorScheme="purple" isLazy>
      <TabList flexWrap="wrap" gap={1}>
        <Tab>LO Profiles</Tab>
        <Tab>Margins</Tab>
        <Tab>Split rules</Tab>
        <Tab>Referral rules</Tab>
        <Tab>LOA fees</Tab>
        <Tab>Email aliases</Tab>
      </TabList>
      <TabPanels>
        <TabPanel px={0}>
          <ProfilesManager isSuperAdmin={isSuperAdmin} onTryInCalculator={onTryInCalculator} />
        </TabPanel>
        <TabPanel px={0}>
          <MarginsManager isSuperAdmin={isSuperAdmin} />
        </TabPanel>
        <TabPanel px={0}>
          <EntityManager config={splitRulesConfig} isSuperAdmin={isSuperAdmin} />
        </TabPanel>
        <TabPanel px={0}>
          <EntityManager config={referralRulesConfig} isSuperAdmin={isSuperAdmin} />
        </TabPanel>
        <TabPanel px={0}>
          <EntityManager config={loaFeesConfig} isSuperAdmin={isSuperAdmin} />
        </TabPanel>
        <TabPanel px={0}>
          <EntityManager config={emailAliasesConfig} isSuperAdmin={isSuperAdmin} />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
}
